import React from 'react';
import Hero from './components/Hero';
import Video from './components/Video';
import WhyUs from './components/WhyUs';
import More from './components/More';
import Footer from './components/Footer';

import './App.css';
const App = () => {
  return(
    <div className='container'>
      <Hero/>
      <div id='video'>
        <Video/>
      </div>
      <div id='why-us'>
        <WhyUs/>
      </div>
      <More/>
      <Footer/>
    </div>
  )
}
export default App;